import React from 'react';
import NewScheme from '../Scheme/newScheme';
import Panel from '../Panel';
import { BuilderBox, SchemeArea, PanelArea } from './style';

function BuilderLayout() {
  return (
    <BuilderBox>
      <SchemeArea>
        <NewScheme />
      </SchemeArea>
      <PanelArea>
        <Panel />
      </PanelArea>
    </BuilderBox>
  );
}

export default BuilderLayout;
